var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H3C1.58579 0 0.87868 0 0.43934 0.412198C0 0.824395 0 1.48782 0 2.81466V3.50448C0 4.54232 0 5.06124 0.2596 5.49142C0.5192 5.9216 0.993473 6.18858 1.94202 6.72255L4.85504 8.36238C5.49146 8.72064 5.80967 8.89977 6.03751 9.09758C6.51199 9.50949 6.80408 9.99352 6.93644 10.5872C7 10.8722 7 11.2058 7 11.8729L7 14.5424C7 15.452 7 15.9067 7.25192 16.2613C7.50385 16.6158 7.95128 16.7907 8.84615 17.1406C10.7248 17.875 11.6641 18.2422 12.3321 17.8244C13 17.4066 13 16.4519 13 14.5424V11.8729C13 11.2058 13 10.8722 13.0636 10.5872C13.1959 9.99351 13.488 9.5095 13.9625 9.09758C14.1903 8.89977 14.5085 8.72064 15.145 8.36238L18.058 6.72255C19.0065 6.18858 19.4808 5.9216 19.7404 5.49142C20 5.06124 20 4.54232 20 3.50448V2.81466C20 1.48782 20 0.824395 19.5607 0.412198C19.1213 0 18.4142 0 17 0Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.26388db850b69e6b7b34cb000b40b17b.svg";
export { ForwardRef as ReactComponent };